import { render } from "./SchedulesList.vue?vue&type=template&id=6d7ee2e0"
import script from "./SchedulesList.vue?vue&type=script&lang=js"
export * from "./SchedulesList.vue?vue&type=script&lang=js"
script.render = render

export default script